import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/fids', pathMatch: 'full' },
  { path: 'fids', loadComponent: () => import('./pages/fid-picker/fid-picker.component').then(m => m.FidPickerComponent), canActivate: [AuthGuard] },
  { path: 'fids/:fid', loadComponent: () => import('./pages/fid-picker/fid-picker.component').then(m => m.FidPickerComponent), canActivate: [AuthGuard] },
  { path: 'fids/:fid/data-readiness', loadComponent: () => import('./pages/data-readiness/data-readiness.component').then(m => m.DataReadinessComponent), canActivate: [AuthGuard] },
  { path: 'fids/:fid/data-viewer', loadComponent: () => import('./pages/data-viewer/data-viewer.component').then(m => m.DataViewerComponent), canActivate: [AuthGuard] },
  { path: 'users', loadComponent: () => import('./pages/user-management/user-management.component').then(m => m.UserManagementComponent), canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/fids' } // Wildcard route for 404 pages
];
